import useAuth from "@/modules/common/hooks/auth.hook";
import usePassport from "@/modules/common/hooks/passport";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { userHasPermission } from "@/modules/common/utils";
import { ActivityItem, ActivityType } from "@/modules/lead-page/dtos/index-v2";

/**
 * Reason hiding: a status update into (or out of) a status flagged `negative` — the
 * disqualification reasons — is visible only to the agent who wrote it and to holders of
 * `journey_status_negative_updates_comments`. Every other agent doesn't see the entry, so a
 * second opinion isn't anchored by the first one.
 *
 * The OLD status is checked too: the engine's neutralize entry reads "from <reason> to needs
 * to be contacted (reassigned)", which would otherwise leak the reason it just hid.
 */
const useHiddenNegativeStatusUpdate = (item: ActivityItem): boolean => {
  const { permissions: currentUserPermissions } = usePassport();
  const { user } = useAuth();

  if (item.type !== ActivityType.StatusUpdate) return false;
  if (!item.newStatusNegative && !item.previousStatusNegative) return false;

  const isAuthor =
    !!item.actorUId && item.actorUId === user?.["cognito:username"];
  if (isAuthor) return false;

  return !userHasPermission(
    {
      name: PermissionsEnum.JOURNEY_STATUS_NEGATIVE_UPDATES_COMMENTS,
      level: PermissionLevel.READ,
    },
    currentUserPermissions,
  );
};

export default useHiddenNegativeStatusUpdate;
